import { render, staticRenderFns } from "./TestTableV2.vue?vue&type=template&id=06f5cbb6&scoped=true"
import script from "./TestTableV2.vue?vue&type=script&lang=ts"
export * from "./TestTableV2.vue?vue&type=script&lang=ts"
import style0 from "./TestTableV2.vue?vue&type=style&index=0&id=06f5cbb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f5cbb6",
  null
  
)

export default component.exports